const footerColumns = [
  {
    title: "资源分区",
    links: ["软件工具", "影视资源", "游戏目录", "视频素材"],
  },
  {
    title: "编辑内容",
    links: ["本周精选", "编辑合集", "更新热榜", "查找指引"],
  },
  {
    title: "关于本站",
    links: ["站点简介", "内容规范", "收录说明", "联系方式"],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-200">
      <div className="mx-auto max-w-[1180px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <span className="font-heading text-lg font-bold leading-none">91</span>
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-background-50">
                91下载
              </span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-7 text-background-300/85">
              91下载是一个面向中文用户的资源索引站，按软件、电影、游戏、视频等分区整理收录条目，并提供编辑合集与更新热榜，帮助浏览者按需快速定位目标内容。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line", "ri-rss-line"].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-primary-800 text-background-300 transition hover:border-accent-400 hover:text-accent-300"
                >
                  <i className={`${icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-7">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
                  {column.title}
                </h4>
                <ul className="mt-4 space-y-2.5">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#top"
                        className="cursor-pointer text-sm text-background-300/85 transition hover:text-accent-300"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 91下载 · 资源大全索引站　页面内容为演示展示，用于说明分区与查找路径。</p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#faq" className="cursor-pointer transition hover:text-accent-300">
              常见问题
            </a>
            <a href="#guide" className="cursor-pointer transition hover:text-accent-300">
              查找指引
            </a>
            <a href="#top" className="cursor-pointer transition hover:text-accent-300">
              返回顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}